<template>
  <div>
    <v-alert v-if="loading" type="info" dense text>Cargando listas de precios…</v-alert>
    <v-alert v-else-if="!hasProducto" type="info" dense text>
      Guarde el producto para gestionar precios por lista.
    </v-alert>
    <template v-else>
      <v-card v-if="precios.length === 1" flat>
        <v-card-text>
          <slot name="preview" :precio-lista="precios[0]" :index="0" />
        </v-card-text>
      </v-card>
      <template v-else>
        <v-tabs v-model="activeTab" show-arrows>
          <v-tab v-for="p in precios" :key="p.lista.id">
            {{ p.lista.nombre }}
            <v-icon v-if="p.lista.isDefault" small right>mdi-star</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="(p, idx) in precios" :key="p.lista.id">
            <v-card flat>
              <v-card-text>
                <slot name="preview" :precio-lista="p" :index="idx" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </template>
    <snackbar v-model="flash" />
  </div>
</template>

<script>
import ListaPreciosVentaProvider from "../../../../lista-precios-venta/providers/ListaPreciosVentaProvider";
import { Snackbar } from "@dracul/common-frontend";

export default {
  name: "ProductoPreciosListaPanel",
  components: { Snackbar },
  props: {
    productoId: { type: [String, Number], default: null },
    producto: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      precios: [],
      activeTab: 0,
      editValues: [],
      savingIdx: null,
      flash: null,
    };
  },
  computed: {
    hasProducto() {
      return !!this.productoId;
    },
  },
  watch: {
    productoId: {
      handler() {
        if (this.productoId) this.cargar();
      },
      immediate: true,
    },
    activeTab() {
      this.emitActivePrecioLista();
    },
  },
  methods: {
    cargar() {
      this.loading = true;
      ListaPreciosVentaProvider.productoPreciosLista(this.productoId)
        .then((r) => {
          this.precios = r.data.productoPreciosLista || [];
          this.editValues = this.precios.map((p) => ({
            margenOverride: p.margenOverride,
            precioVentaOverride: p.precioVentaOverride,
          }));
          this.emitActivePrecioLista();
        })
        .catch((err) => {
          console.error(err);
          this.flash = err.message;
        })
        .finally(() => (this.loading = false));
    },
    emitActivePrecioLista() {
      this.$emit("active-change", this.precios[this.activeTab] || null);
    },
    margenEfectivo(p) {
      if (p.margenOverride != null) return p.margenOverride;
      if (p.lista?.formulaConfig?.margenDefault != null) return p.lista.formulaConfig.margenDefault;
      return this.producto?.porcentajeSobreCosto ?? 0;
    },
    margenFuente(p) {
      if (p.margenOverride != null) return "override del producto en esta lista";
      if (p.lista?.formulaConfig?.margenDefault != null) return "default de la lista";
      return "del producto";
    },
    redondeoEfectivo(p) {
      const t = p.lista?.formulaConfig?.tipoRedondeo ?? this.producto?.tipoRedondeo ?? "ninguno";
      return t;
    },
    redondeoFuente(p) {
      if (p.lista?.formulaConfig?.tipoRedondeo != null) return "override de la lista";
      if (this.producto?.tipoRedondeo) return "del producto";
      return "default";
    },
    guardarMargen(idx) {
      this.savingIdx = idx;
      const v = this.editValues[idx].margenOverride;
      const margenOverride = v === "" || v == null ? null : Number(v);
      ListaPreciosVentaProvider.setMargen(this.productoId, this.precios[idx].lista.id, margenOverride)
        .then(() => {
          this.flash = "Margen guardado";
          this.cargar();
        })
        .catch((err) => (this.flash = err.message))
        .finally(() => (this.savingIdx = null));
    },
    guardarOverride(idx) {
      this.savingIdx = idx + 1000;
      const v = this.editValues[idx].precioVentaOverride;
      const override = v === "" || v == null ? null : Number(v);
      ListaPreciosVentaProvider.setOverride(this.productoId, this.precios[idx].lista.id, override)
        .then(() => {
          this.flash = "Precio override guardado";
          this.cargar();
        })
        .catch((err) => (this.flash = err.message))
        .finally(() => (this.savingIdx = null));
    },
  },
};
</script>
